import {Button, Col, DatePicker, Form, Input, InputNumber, Row, Select} from 'antd';
import React from 'react';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';

const {TextArea} = Input;

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const DetailOtherActivity = () => {
	const apiList = [Arguments.host + '/society_organization/society/api!addOtherActivity.do'];
	return (
		<EditFormComponent UserForm={OtherActivityForm} url={apiList}/>
	);
};

const OtherActivityForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			initialValues={initialValues}
			onFinish={onFinish}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityName" label="活动名称" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activitySubject" label="活动主题" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="activityDate" label="活动时间" rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期" disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="activityScope" label="活动规模"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}} disabled={true}/>
					</Form.Item>
				</Col>
			</Row>


			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityAddress" label="活动地址" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>


			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityExpert" label="发言嘉宾" rules={[{required: true, message: '内容不能为空'}]}>
						<TextArea placeholder="请注明发言嘉宾的工作单位！" rows={7} disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityMemo" label="活动备注" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="checkStatus" label="审核状态" rules={[{required: true, message: '内容不能为空'}]}
					>
						<Select>
							<Select.Option value="通过">通过</Select.Option>
							<Select.Option value="驳回">驳回</Select.Option>
							<Select.Option value="未审">未审</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailOtherActivity;
